import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import * as EntitiesReducer from '_reducers/entities.reducer'
import * as UIReducer from '_reducers/ui.reducer'
import { ActionNames } from '_constants'
import actionProcessor from '_services/actionProcessor.service'

var store;

export default function configureStore(history, initialState) {
    const reducers = {
        entities: EntitiesReducer.reducer,
        ui: UIReducer.reducer
    };

    const middleware = [
        thunk,
        routerMiddleware(history),
        actionProcessor
    ];

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.REACT_APP_ENV === 'development';
    const isStaging = process.env.REACT_APP_ENV === 'staging';
    if ((isDevelopment || isStaging) && typeof window !== 'undefined' && window.devToolsExtension) {
        enhancers.push(window.devToolsExtension());
    }

    const uiMonitor = require('_services/uiMonitor.service').default;
    middleware.push(uiMonitor);
    const queueMiddleware = require('_services/actionQueue.service').default;
    middleware.push(queueMiddleware);

    if (isDevelopment || isStaging) {
    const loggerMiddleware = require('_services/actionLogger.service').default;
    middleware.push(loggerMiddleware);
    const enhancer = require('_services/reducerMonitor.service').default;
    enhancers.push(enhancer);
    }


    const appReducer = combineReducers({
        ...reducers,
        routing: routerReducer
    });

    const rootReducer = (state, action) => {
        if (action.type === ActionNames.LOGOUT_SUCCESS || action.type === ActionNames.SEND_ERROR_REPORT_SUCCESS) {
            state = undefined;
        }

        return appReducer(state, action);
    }

    store = createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers)
    );


    return store;
}

export { store }